import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import shouldPureComponentUpdate from 'react-pure-render/function';
import InlineSVG from 'svg-inline-react';

import Tag from 'components/Tag/Tag';
import LinkSubPage from 'components/LinkSubPage/LinkSubPage';
import calendar from './calendar.svg';

import './LinkInput.scss';


class LinkInput extends Component {
  static propTypes = {
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    children: PropTypes.string,
    placeholder: PropTypes.string,
    onTagClick: PropTypes.func,
    hasTag: PropTypes.bool,
    hasCalendarIcon: PropTypes.bool,
    reportSearchFieldClicked: PropTypes.func,
    onClick: PropTypes.func,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    placeholder: 'Any',
    url: '#',
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  saveLinkRef = ref => this.linkRef = ref;

  handleClick = (event) => {
    const { url, onClick, reportSearchFieldClicked } = this.props;

    if (url === '#') {
      event.preventDefault();
    }

    if (onClick) {
      onClick(event, ReactDOM.findDOMNode(this.linkRef));
    }

    if (reportSearchFieldClicked) {
      reportSearchFieldClicked(event);
    }
  }

  render() {
    const { url, hasTag, hasCalendarIcon, children, placeholder, location, label, onTagClick } = this.props;
    const text = children || placeholder;
    return (
      <div className="link-input" ref={this.saveLinkRef}>
        { label && (
          <LinkSubPage to={url} location={location} className="link-input__label" onClick={this.handleClick} tabIndex="-1">
            {label}
          </LinkSubPage>
        )}
        { hasTag ? (
          <div className="link-input__input link-input__input--tag">
            <Tag onTagClick={onTagClick}>{text}</Tag>
            { hasCalendarIcon && (
              <LinkSubPage
                to={url}
                location={location}
                onClick={this.handleClick}
                className="link-input__cal-icon__link"
              >
                <InlineSVG src={calendar} className="cal-icon" />
              </LinkSubPage>

            )}
          </div>
        ) : (
          <LinkSubPage
            to={url}
            location={location}
            className={`link-input__input ${children ? '' : 'link-input__input--is-placeholder'}`}
            onClick={this.handleClick}
          >
            {text}
            { hasCalendarIcon && <InlineSVG src={calendar} className="cal-icon" /> }
          </LinkSubPage>
        )}
      </div>
    );
  }
}

export default LinkInput;



/** WEBPACK FOOTER **
 ** ./src/components/LinkInput/LinkInput.jsx
 **/